/**
 * Shared PostHog constants. Lives in its own module because `~/lib/posthog` is
 * server-only — importing these from there would drag posthog-node into the
 * browser bundle.
 */

/**
 * Stamped onto every PostHog event from this app, browser and server alike, so
 * one property separates portal traffic from every other producer in the
 * project.
 */
export const ANALYTICS_SOURCE = "api-portal" as const;

/**
 * The group type every org-scoped event attaches to.
 *
 * This is the type the rest of the products (the Go and Python backends, the
 * main web app) already write and maintain group properties on, so the portal
 * shares it rather than keeping its own parallel `api_organization` type — an
 * org viewed in PostHog should show its portal, API, and product activity in
 * one place. Portal events before this change remain under the old type.
 */
export const ORG_GROUP_TYPE = "organization" as const;
